import React, {FunctionComponent, useContext} from 'react';
import './ActivityTile.scss';
import {UserAvatar} from "../UserAvatar/UserAvatar";
import {Activity} from "../../models/activity.model";
import styled from "styled-components";
import {ThemeContext} from "../../context/ThemeContext";
import {Theme} from "../../models/theme.model";

interface ActivityTileProps {
    activity: Activity;
}

const StyledActivityTile = styled.div`
  &&& {
    
  }
`;

export const ActivityTile: FunctionComponent<ActivityTileProps> = (props) => {
    const {activity} = props;
    const theme: Theme = useContext(ThemeContext).theme;

    return (
        <StyledActivityTile theme={theme} className='activity-tile'>
            <div className="comment-logo">
                <UserAvatar initials={activity.author_initials} avatar={activity.author_logo_src}/>
            </div>

            <div className="activity-tile-content">
                <div className='activity-creation-date'>
                    {activity.created_at}
                </div>

                <div className='activity-text'>
                    {activity.text}
                </div>
            </div>
        </StyledActivityTile>
    );
};